/* istanbul ignore file */
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'app-banner-section',
  templateUrl: './banner-section.component.html',
  styleUrls: ['./banner-section.component.scss']
})
export class BannerSectionComponent implements OnInit{
  bannerText:string;
  bannerSubText:string;
  textOnLink:string;
  @Input() showPendingPhonesNotification?: boolean = false;
  @Input() showFailedPhonesNotification?: boolean = false;
  @Input() isPhonePlanSupported?: boolean = false;
  @Input() isSuspended?: boolean = false;

  constructor(
    private matDialog: MatDialog,
    private router: Router,
    private resourceService: ADPResourceService,
  ) { }

  async ngOnInit(){

    if(this.showPendingPhonesNotification){
      this.bannerText = this.resourceService.getPortalLabel("Dashboard_Notification_PendingTest_Banner_Text").Value;
      this.bannerSubText = this.resourceService.getPortalLabel("Dashboard_Notification_PendingTest_Banner_Subtext").Value;
      this.textOnLink = this.resourceService.getPortalLabel("Dashboard_Notification_PendingPhones_Banner_Link").Value;;
    }

    if(this.showFailedPhonesNotification){
      this.bannerText = this.resourceService.getPortalLabel("Dashboard_Notification_FailedTest_Banner_Text").Value;
      this.bannerSubText = this.resourceService.getPortalLabel("Dashboard_Notification_FailedTest_Banner_Subtext").Value;
      this.textOnLink = this.resourceService.getPortalLabel("Dashboard_Notification_FailedPhones_Banner_Link").Value;;
    }

    if(this.isSuspended){
      this.bannerText = this.resourceService.getPortalLabel("Dashboard_Notification_Suspended_Banner_Text").Value;
      this.bannerSubText = this.resourceService.getPortalLabel("Dashboard_Notification_Suspended_Banner_Subtext").Value;
    }
  }

  viewMyDevices()
  {
    this.router.navigate([this.resourceService.getPortalSetting("URL_MyDevices").Value]);
  }


}
